import { Form, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { Controller } from "react-hook-form";

/**
 * Component has been deprecated and should not be used anymore.
 * @deprecated Use components from shared/ui instead
 */
function FormToggleButtonGroup({
  name,
  options = [],
  label = "",
  displayAs = Form.Group,
  ...props
}) {
  return (
    <Form.Group className="d-flex flex-column" as={displayAs} md>
      <Form.Label>{label}</Form.Label>
      <Controller
        name={name}
        render={({ field }) => (
          <ToggleButtonGroup {...field} {...props} className="d-inline">
            {options.map((option) => {
              return (
                <ToggleButton
                  key={option}
                  id={option}
                  className="text-light"
                  value={option}
                  name={option}
                >
                  {option}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        )}
      />
    </Form.Group>
  );
}

export default FormToggleButtonGroup;
